//Built-in libraries

//Third party libraries
import { useLocation, useNavigate } from 'react-router-dom';

//Custom components
import { CurrencyFormatDisplay } from 'components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import Table from 'components/UI/Table';
import { BFIPFiltersForm } from './BFIPFiltersForm';

//Services
import { convertEnumToText } from 'utils';
import { useApplicationsListContext } from 'features/ApplicationForm/Components/ApplicationsList/ApplicationsListProvider';

//STP Libraries

//Assets and Miscellaneous
import Styles from './styles.module.css';

//Component Begin

export const BFIPApplicationsList = () => {
  const {
    data,
    tablePagination,
    showFilterModal,
    toggleFilterModal,
    applyFiltersHandler,
  } = useApplicationsListContext();

  const navigate = useNavigate();
  const location = useLocation();

  const tableColumns = [
    {
      id: 'fullName',
      Header: 'Applicant Name',
      accessor: 'applicationData',
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        const applicationInformation = row.value?.applicantInformation;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>{applicationInformation?.fullName}</span>
            <span className='text-xs text-neutralColor-normal'>
              {applicationInformation.contactEmail}
            </span>
          </div>
        );
      },
    },
    {
      id: 'client',
      Header: 'Client',
      accessor: 'applicationData',
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        const projectDetails = row?.value?.step1?.section1;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>
              {projectDetails?.buildingOwners.map(
                (owner: any) => ` ${owner?.name},`
              )}
            </span>
            <span className='text-xs text-neutralColor-normal'>
              {projectDetails?.streetAddress},{' '}
              {projectDetails?.state}, {projectDetails?.zipCode}
            </span>
          </div>
        );
      },
    },
    {
      id: 'amountRequested',
      Header: 'Amount Requested',
      accessor: 'applicationData',
      minWidth: 200,
      maxWidth: 200,
      Cell: (row: any) => {
        const proposedFinancing = row?.value?.step3?.section2;
        const source = proposedFinancing.find((f:any) => f?.source === 'Façade Program Assistance')
        const totalCost = source ? source?.totalCost: 0
        return (
          <div className='flex flex-col gap-1'>
            <CurrencyFormatDisplay
              value={totalCost}
              prefix='$'
            />
          </div>
        );
      },
    },
    // {
    //   id: 'acquisitionType',
    //   Header: 'Project Overview',
    //   accessor: 'applicationData.projectDetails.acquisitionType',
    //   minWidth: 200,
    //   maxWidth: 200,
    // },
    // {
    //   id: 'constructionType',
    //   Header: 'Economic Overview',
    //   accessor: 'applicationData.projectDetails.constructionType',
    //   minWidth: 200,
    //   maxWidth: 200,
    // },
    {
      id: 'status',
      Header: 'Status',
      accessor: 'status',
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        return (
          <div className='flex items-center w-full capitalize'>
            <span className={`${Styles[row.value]}`}>
              {convertEnumToText(row.value)}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Table
        cols={tableColumns}
        tableData={data?.data}
        onRowClick={(row: any) => navigate(`${location.pathname}/${row.id}`)}
        pagination={tablePagination}
      />

      {showFilterModal && (
        <BFIPFiltersForm
          handleModal={toggleFilterModal}
          handleApplyFilter={applyFiltersHandler}
        />
      )}
    </>
  );
};
